/** Дата и время в зоне браузера, по-русски. С бэкенда приходит ISO 8601. */
const dateTime = new Intl.DateTimeFormat('ru-RU', { dateStyle: 'medium', timeStyle: 'short' });

export function formatDateTime(iso: string): string {
  return dateTime.format(new Date(iso));
}

/**
 * Дата и время в названной зоне — у практики своя (`timeZone`), и «начало в 19:00» значит
 * 19:00 там, где она проходит, а не у администратора. Зона, которую браузер не знает,
 * даёт `RangeError`; тогда — зона браузера, а не пустая ячейка.
 */
export function formatDateTimeIn(iso: string, timeZone: string): string {
  try {
    return new Intl.DateTimeFormat('ru-RU', {
      dateStyle: 'medium',
      timeStyle: 'short',
      timeZone,
    }).format(new Date(iso));
  } catch (error) {
    if (error instanceof RangeError) return formatDateTime(iso);
    throw error;
  }
}

/** Подписи способов входа: `providers` контракта — коды, а на экране нужны слова. */
export const PROVIDER_LABEL: Record<string, string> = { email: 'email', telegram: 'Telegram' };
